export const PHONE_NUMBER_MIN_LENGTH = 10
export const PHONE_NUMBER_MAX_LENGTH = 18
